import React from 'react';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const { footer } = mockData;

  return (
    <footer id="contato" className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img
                src="/img/eedoc_white.png"
                alt="EEDOC Logo"
                className="h-8"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {footer.company.description}
            </p>
            <p className="text-gray-500 text-xs italic">
              {footer.company.tagline}
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Produto</h3>
            <ul className="space-y-3">
              {footer.links.product.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-purple-400 transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Empresa</h3>
            <ul className="space-y-3">
              {footer.links.company.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-purple-400 transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-purple-400 flex-shrink-0 mt-0.5" />
                <a 
                  href="mailto:eedoc@gatewaysistemas.com.br" 
                  className="text-gray-400 hover:text-purple-400 transition-colors duration-200 text-sm"
                >
                  eedoc@gatewaysistemas.com.br
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-purple-400 flex-shrink-0 mt-0.5" />
                <a 
                  href="tel:+5515991089431" 
                  className="text-gray-400 hover:text-purple-400 transition-colors duration-200 text-sm"
                >
                  (15) 99108-9431
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-purple-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  Itapetininga, São Paulo
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Access Portal */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <div className="text-center">
              <p className="text-gray-400 text-sm mb-2">
                Já é cliente? Acesse o sistema agora:
              </p>
              <button
                onClick={() => window.open(footer.contact.portal, '_blank')}
                className="inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <span>Acessar Portal</span>
                <ExternalLink className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        {/* Legal Links */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 EEDOC. Todos os direitos reservados.
            </p>
            <div className="flex items-center space-x-6">
              {footer.links.legal.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="text-gray-500 hover:text-purple-400 transition-colors duration-200 text-sm"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
